import React, { createContext, useContext, useState, useEffect } from 'react';
import { MACHIN_ID, SYSTEM_INFO,GetClientType } from '../config';

import { useTranslation } from 'react-i18next';

import {t} from "i18next";

const BrowserContext = createContext(undefined);
console.log('v.1.0.0')
export const BrowserProvider = ({ children }) => {
    const { t } = useTranslation();
    const [browserLoading, setBrowserLoading] = useState(true);
    const [browser, setBrowser] = useState({});
   

    const isRevit = typeof window.AddInBridge !== "undefined"; // Detects Revit
    const isMax = !isRevit && typeof window !== "undefined"; // Detects 3ds Max

    // Wraps a function dynamically based on the platform
    const wrapFunction = (funcName, defaultReturn = '') => {
        if (isRevit) {
            return async (...args) => {
                try {
                    return await window.AddInBridge[funcName](...args);
                } catch (error) {
                    console.error(`Error calling ${funcName} in Revit:`, error);
                    return defaultReturn;
                }
            };
        } else {
            
            if (['appPlaber','appSpherical','appBox','appRotate'].includes(funcName)) {
                return (...args) => window[funcName]?.() || defaultReturn;

            }
            return (...args) => window[funcName]?.(...args) || defaultReturn;
        }
    };

    // Get Download Path
    const getDownloadPath = () => {
        if (isRevit) {  
            return window.AddInBridge.appDownloadPath();
        } else {
            return window.appDownloadPath() || '';

        }
     
    };

    // Get File Path (shared logic)
    const getFilePath = async (product,type="") => {
        let fileName = product.name + '.zip';
        let subDirectory = 'assets';
        if(type == "texture"){
            subDirectory="texture"
        }
        const downloadPath = await getDownloadPath();
        if(GetClientType() == "revit"){
            fileName = product.name
             subDirectory = "Archives"
          

            return `${downloadPath}\\${subDirectory}\\${fileName}`;

        }
        return `${downloadPath}\\${subDirectory}\\${product.name}\\${fileName}`;
    };
    const getExtentionByType = (type)=>{
       return type == "material" ? ".rvt":'.rfa';
    }

    // Get File Info
    const getFileinfo = async (filePath) => {
        
        if (isRevit) {
            try {
                return await window.AddInBridge.appFileInfo(filePath+'.zip');
            } catch (error) {
                console.error("Error getting file info in Revit:", error);
                return { exists: false, size: 0 };
            }
        }

        return JSON.parse(window.appFileInfo?.(filePath) || '{"exists":false,"size":0}');
    };

    // Execute Render Functions (Shared)
    const executeRenderFunction = async (funcName, product, type = '') => {
        const filePath = await getFilePath(product,type);
        const fileInfo = await getFileinfo(filePath,type);
     
        if (isRevit) {
            const info = JSON.parse(fileInfo)
            if (!info.exists) {
                return t("download.file_not_exists_first_download")
            }
            if(type ==="material"){
                
                return window.AddInBridge.appApplyMaterial(product.name+getExtentionByType(type),product.name);

            }else if(type === "object"){
                return window.AddInBridge.appAddObject(product.name);
            }
            else{
                return window.AddInBridge[funcName](filePath);
                }
        } else {
            if (!fileInfo.exists ) return t("download.file_not_exists_first_download");
            return window[funcName]?.(filePath) || true;
        }
    };

    useEffect(() => {
        if (!isRevit && !isMax) return;

        setBrowser({
            // Shared Functions (Revit & 3ds Max)
            getFileinfo,
            deleteFile: wrapFunction("deleteFile"),
            appGetFiles: wrapFunction("appGetFiles", "[]"),
            getSysInfo:  wrapFunction("appGetSysInfo", SYSTEM_INFO),
            getMachinId:   wrapFunction("appGetMachineId", SYSTEM_INFO),
            getDownloadPath,
            appUserSelectDownloadFolder: wrapFunction("appUserSelectDownloadFolder"),
            
            // 3ds Max Specific Functions
            vray: (product) => executeRenderFunction("appVray", product),
            corona: (product) => executeRenderFunction("appCorona", product),
            vrayTexture: (product) => executeRenderFunction("appVray", product,'texture'),
            coronaTexture: (product) => executeRenderFunction("appCorona", product,'texture'),
            planar: wrapFunction("appPlaber"),
            spherical: wrapFunction("appSpherical"),
            box: wrapFunction("appBox"),
            rotate: wrapFunction("appRotate"),
            applyUVW: (product, value, uvmType) => wrapFunction("appApplyUVM")(value, uvmType),
            apply: (product, hue, saturation, brightness, contrast) =>
                wrapFunction("appApply")(hue, saturation, brightness, contrast),
            addToProject: (product) => executeRenderFunction("appAddToProject", product),
            addToLine: (product) => executeRenderFunction("appAddToLine", product),
            appApplyRenderSettings: (engine, quality, size) =>
                wrapFunction("appApplyRenderSettings")(engine, quality, size),

            // Revit Specific Functions
            appApplyMaterial: (product) => executeRenderFunction("appApplyMaterial", product, 'material'),
            appAddToObject: (product) => executeRenderFunction("appAddObject", product, 'object'),
            appClient:  wrapFunction("appClient"),
            appClientVersion: wrapFunction("appClientVersion"),
        });
     
        setBrowserLoading(false);
    }, [isRevit, isMax]);

    return (
        <BrowserContext.Provider value={{ browser, browserLoading,getFilePath,getFileinfo }}>
            {children}
        </BrowserContext.Provider>
    );
};

export const useBrowser = () => useContext(BrowserContext);
